// extracted by mini-css-extract-plugin
export default {"label":"selectfield_label__9p+HD","labelText":"selectfield_labelText__pDffq","textSmall":"selectfield_textSmall__qHjkj","inputGroup":"selectfield_inputGroup__R3OlH"};